// eslint-disable-next-line
import tw from "twin.macro";
import { Link } from "gatsby";
import Zoom from "react-reveal/Zoom";
import Slide from "react-reveal/Slide";

import { GrInstagram, GrLinkedinOption, GrMailOption } from "react-icons/gr";
import React from "react";

const FooterData = [
  {
    name: "Home",
    link: "/",
  },
  {
    name: "services",
    link: "/services",
  },
  {
    name: "Training",
    link: "/training",
  },
  {
    name: "Teams",
    link: "/teams",
  },
  {
    name: "Clients",
    link: "/clients",
  },
  {
    name: "Contact",
    link: "/contacts",
  },
  // {
  //   name: "Career",
  //   link: "/career",
  // },
];

const FooterSocial = [
  {
    icon: GrInstagram,
    link: "https://www.instagram.com/techtomatoes",
  },
  {
    icon: GrLinkedinOption,
    link: "https://www.linkedin.com/company/tech-tomatoes/",
  },
  {
    icon: GrMailOption,
    link: "mailto:tech.tomatoes.india@gmail.com",
  },
];

const Footer = () => {
  return (
    <div tw="w-full min-h-full flex items-center justify-center bg-black  pt-10">
      <div tw="md:w-2/3 w-full px-4 text-white flex flex-col">
        <Slide top cascade>
          <div tw="w-full text-xl leading-10 md:text-5xl font-bold">
            <h1 tw="w-full md:w-2/3">A startup behind your startup</h1>
          </div>
          <div tw="flex mt-8 flex-col md:flex-row md:justify-between">
            <p tw="w-full md:w-2/3 text-gray-400">
              Bundled with lots of Cutting edge technological solutions for you
              and your enterprise
            </p>
            <div tw="w-44 pt-6 mx-auto md:pt-0">
              <Link
                to="/get-quote"
                tw="rounded-bl-3xl rounded-tr-3xl text-white font-medium no-underline bg-red-500 hover:bg-red-600  p-3 md:p-5  shadow px-10 py-3"
              >
                Get a Quote!
              </Link>
            </div>
          </div>
        </Slide>
        <div tw="flex flex-col">
          <Zoom top cascade>
            <div tw=" grid grid-cols-3 gap-5 md:flex mt-24 mb-12 flex-row justify-between">
              {FooterData.map((item, index) => (
                <Link
                  to={item.link}
                  key={index}
                  tw="block cursor-pointer text-gray-600 hover:text-white uppercase"
                >
                  {item.name}
                </Link>
              ))}
              <div tw="flex flex-row space-x-8 items-center justify-between">
                {FooterSocial.map((item, index) => (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={item.link}
                    key={index}
                    tw="h-1 w-1 text-white"
                  >
                    <item.icon />
                  </a>
                ))}
              </div>
            </div>
          </Zoom>
          <hr tw="border-gray-600" />
          <p tw="w-full text-center mt-12 mb-2 text-gray-600">
            Copyright © 2021 Tech Tomatoes{" "}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
